import {
    Card,
    CardContent,
    Stack,
    Typography
} from "@mui/material";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ApartmentIcon from "@mui/icons-material/Apartment";
import GroupsIcon from "@mui/icons-material/Groups";

import styles from "../styles/firstDayDetailsBanner.module.scss";

export default function FirstDayDetailsBanner({
    title = "Your first day details:",
    startDate = "",
    location = "",
    contactName = "",
    contactRole = "",
    contactNumber = ""
}) {

    const formattedStartDate = (() => {

        if (!startDate) return "";

        const date = new Date(startDate);

        if (Number.isNaN(date.getTime())) {
            return "";
        }

        return new Intl.DateTimeFormat("en-GB", {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric"
        }).format(date);

    })();

    return (
        
        <section className={styles.banner}>
            

            <div className={styles.content}>
                <Typography variant="h1" sx={{ fontSize: "2rem", fontWeight:700, mb:"20px"}}>
                    {title}
                </Typography>
                

                <div className={styles.cardContainer}>

                    <Card
                        className={styles.card}
                        elevation={3}
                    >

                        <CardContent>

                            <Stack
                                spacing={2}
                                alignItems="center"
                                height="100%"
                            >

                                <Typography
                                    variant="h6"
                                    className={styles.heading}
                                >
                                    My first day
                                </Typography>

                                <CalendarMonthIcon
                                    className={styles.icon}
                                />

                                <Typography
                                    className={styles.detail}
                                >
                                    Your first day is on
                                </Typography>

                                <Typography
                                    variant="subtitle1"
                                    className={styles.value}
                                >
                                    {formattedStartDate}
                                </Typography>

                            </Stack>

                        </CardContent>

                    </Card>

                    <Card
                        className={styles.card}
                        elevation={3}
                    >

                        <CardContent>

                            <Stack
                                spacing={2}
                                alignItems="center"
                                height="100%"
                            >

                                <Typography
                                    variant="h6"
                                    className={styles.heading}
                                >
                                    Location
                                </Typography>

                                <ApartmentIcon
                                    className={styles.icon}
                                />

                                <Typography
                                    className={styles.detail}
                                >
                                    Your first day will be at
                                </Typography>

                                <Typography
                                    variant="subtitle1"
                                    className={styles.value}
                                >
                                    {location}
                                </Typography>

                            </Stack>

                        </CardContent>

                    </Card>

                    <Card
                        className={styles.card}
                        elevation={3}
                    >

                        <CardContent>

                            <Stack
                                spacing={2}
                                alignItems="center"
                                height="100%"
                            >

                                <Typography
                                    variant="h6"
                                    className={styles.heading}
                                >
                                    Who you'll meet
                                </Typography>

                                <GroupsIcon
                                    className={styles.icon}
                                />

                                <Typography
                                    className={styles.contactText}
                                >
                                    On arrival,{" "}
                                    <strong>{contactName}</strong>
                                    {contactRole && (
                                        <>
                                            , <strong>{contactRole}</strong>
                                        </>
                                    )}{" "}
                                    will meet with you.
                                </Typography>

                                {contactName && contactNumber && (

                                    <Typography
                                        className={styles.contactText}
                                    >
                                        If you have any questions before your first day,
                                        please call{" "}
                                        <strong>{contactName}</strong>{" "}
                                        on{" "}
                                        <strong>{contactNumber}</strong>.
                                    </Typography>

                                )}

                            </Stack>

                        </CardContent>

                    </Card>

                </div>

            </div>

        </section>

    );

}